module.exports = __webpack_public_path__ + "img/album06_07.7396488f.jpg";